export default __webpack_public_path__ + "static/6829-6bc2ab08082cbde14cf86478e14e3dbc.jpg";